// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as adminRouteRouteImport } from './routes/(admin)/route'
import { Route as ProsekitTestRouteImport } from './routes/prosekit-test'
import { Route as adminIndexRouteImport } from './routes/(admin)/index'
import { Route as adminOrgIdRouteRouteImport } from './routes/(admin)/$orgId/route'
import { Route as adminHomeRouteRouteImport } from './routes/(admin)/home/route'
import { Route as adminInboxRouteRouteImport } from './routes/(admin)/inbox/route'
import { Route as adminMineRouteRouteImport } from './routes/(admin)/mine/route'
import { Route as adminSettingsRouteRouteImport } from './routes/(admin)/settings/route'
import { Route as Auth2faRouteImport } from './routes/auth/2fa'
import { Route as AuthConsentRouteImport } from './routes/auth/consent'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthPasswordResetRouteImport } from './routes/auth/password-reset'
import { Route as AuthReauthRouteImport } from './routes/auth/reauth'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as OrgsOrgSlugRouteRouteImport } from './routes/orgs/$orgSlug/route'
import { Route as adminOrgIdIndexRouteImport } from './routes/(admin)/$orgId/index'
import { Route as adminOrgIdTasksRouteRouteImport } from './routes/(admin)/$orgId/tasks/route'
import { Route as adminConsoleIndexRouteImport } from './routes/(admin)/console/index'
import { Route as adminHomeIndexRouteImport } from './routes/(admin)/home/index'
import { Route as adminInboxIndexRouteImport } from './routes/(admin)/inbox/index'
import { Route as adminMineIndexRouteImport } from './routes/(admin)/mine/index'
import { Route as adminSettingsIndexRouteImport } from './routes/(admin)/settings/index'
import { Route as adminSettingsConnectionsRouteRouteImport } from './routes/(admin)/settings/connections/route'
import { Route as InviteOrgIdIndexRouteImport } from './routes/invite/$orgId/index'
import { Route as OrgsOrgSlugIndexRouteImport } from './routes/orgs/$orgSlug/index'
import { Route as adminOrgIdReleasesIndexRouteImport } from './routes/(admin)/$orgId/releases/index'
import { Route as adminOrgIdReleasesReleaseSlugRouteImport } from './routes/(admin)/$orgId/releases/$releaseSlug'
import { Route as adminOrgIdTasksIndexRouteImport } from './routes/(admin)/$orgId/tasks/index'
import { Route as adminOrgIdTasksTaskShortIdRouteRouteImport } from './routes/(admin)/$orgId/tasks/$taskShortId/route'
import { Route as adminConsoleConnectionsIndexRouteImport } from './routes/(admin)/console/connections/index'
import { Route as adminConsoleOrganizationsOrgIdRouteImport } from './routes/(admin)/console/organizations/$orgId'
import { Route as adminConsoleUsersUserIdRouteImport } from './routes/(admin)/console/users/$userId'
import { Route as adminSettingsApiKeysIndexRouteImport } from './routes/(admin)/settings/api-keys/index'
import { Route as adminSettingsConnectionsIndexRouteImport } from './routes/(admin)/settings/connections/index'
import { Route as adminSettingsOrgOrgIdRouteRouteImport } from './routes/(admin)/settings/org/$orgId/route'
import { Route as adminSettingsSecurityIndexRouteImport } from './routes/(admin)/settings/security/index'
import { Route as OrgsOrgSlugShortIdIndexRouteImport } from './routes/orgs/$orgSlug/$shortId/index'
import { Route as OrgsOrgSlugActivityIndexRouteImport } from './routes/orgs/$orgSlug/activity/index'
import { Route as OrgsOrgSlugNewIndexRouteImport } from './routes/orgs/$orgSlug/new/index'
import { Route as OrgsOrgSlugReleasesIndexRouteImport } from './routes/orgs/$orgSlug/releases/index'
import { Route as OrgsOrgSlugRoadmapIndexRouteImport } from './routes/orgs/$orgSlug/roadmap/index'
import { Route as adminOrgIdTasksTaskShortIdIndexRouteImport } from './routes/(admin)/$orgId/tasks/$taskShortId/index'
import { Route as adminSettingsOrgOrgIdIndexRouteImport } from './routes/(admin)/settings/org/$orgId/index'
import { Route as OrgsOrgSlugReleasesReleaseSlugIndexRouteImport } from './routes/orgs/$orgSlug/releases/$releaseSlug/index'
import { Route as adminSettingsOrgOrgIdAiIndexRouteImport } from './routes/(admin)/settings/org/$orgId/ai/index'
import { Route as adminSettingsOrgOrgIdBillingIndexRouteImport } from './routes/(admin)/settings/org/$orgId/billing/index'
import { Route as adminSettingsOrgOrgIdCategoriesIndexRouteImport } from './routes/(admin)/settings/org/$orgId/categories/index'
import { Route as adminSettingsOrgOrgIdConnectionsIndexRouteImport } from './routes/(admin)/settings/org/$orgId/connections/index'
import { Route as adminSettingsOrgOrgIdLabelsIndexRouteImport } from './routes/(admin)/settings/org/$orgId/labels/index'
import { Route as adminSettingsOrgOrgIdMembersIndexRouteImport } from './routes/(admin)/settings/org/$orgId/members/index'
import { Route as adminSettingsOrgOrgIdTeamsIndexRouteImport } from './routes/(admin)/settings/org/$orgId/teams/index'
import { Route as adminSettingsOrgOrgIdTeamsNewRouteImport } from './routes/(admin)/settings/org/$orgId/teams/new'
import { Route as adminSettingsOrgOrgIdTemplatesIndexRouteImport } from './routes/(admin)/settings/org/$orgId/templates/index'
import { Route as adminSettingsOrgOrgIdViewsIndexRouteImport } from './routes/(admin)/settings/org/$orgId/views/index'
import { Route as adminSettingsOrgOrgIdConnectionsIntegrationIdIndexRouteImport } from './routes/(admin)/settings/org/$orgId/connections/$integrationId/index'
import { Route as adminSettingsOrgOrgIdConnectionsGithubIndexRouteImport } from './routes/(admin)/settings/org/$orgId/connections/github/index'
import { Route as adminSettingsOrgOrgIdTeamsTeamIdIndexRouteImport } from './routes/(admin)/settings/org/$orgId/teams/$teamId/index'

const adminRouteRoute = adminRouteRouteImport.update({
            id: '/(admin)',getParentRoute: () => rootRouteImport
          })
const ProsekitTestRoute = ProsekitTestRouteImport.update({
            id: '/prosekit-test',path: '/prosekit-test',getParentRoute: () => rootRouteImport
          })
const adminIndexRoute = adminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminRouteRoute
          })
const adminOrgIdRouteRoute = adminOrgIdRouteRouteImport.update({
            id: '/$orgId',path: '/$orgId',getParentRoute: () => adminRouteRoute
          })
const adminHomeRouteRoute = adminHomeRouteRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => adminRouteRoute
          })
const adminInboxRouteRoute = adminInboxRouteRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => adminRouteRoute
          })
const adminMineRouteRoute = adminMineRouteRouteImport.update({
            id: '/mine',path: '/mine',getParentRoute: () => adminRouteRoute
          })
const adminSettingsRouteRoute = adminSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => adminRouteRoute
          })
const Auth2faRoute = Auth2faRouteImport.update({
            id: '/auth/2fa',path: '/auth/2fa',getParentRoute: () => rootRouteImport
          })
const AuthConsentRoute = AuthConsentRouteImport.update({
            id: '/auth/consent',path: '/auth/consent',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
            id: '/auth/password-reset',path: '/auth/password-reset',getParentRoute: () => rootRouteImport
          })
const AuthReauthRoute = AuthReauthRouteImport.update({
            id: '/auth/reauth',path: '/auth/reauth',getParentRoute: () => rootRouteImport
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/auth/signup',path: '/auth/signup',getParentRoute: () => rootRouteImport
          })
const OrgsOrgSlugRouteRoute = OrgsOrgSlugRouteRouteImport.update({
            id: '/orgs/$orgSlug',path: '/orgs/$orgSlug',getParentRoute: () => rootRouteImport
          })
const adminOrgIdIndexRoute = adminOrgIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminOrgIdRouteRoute
          })
const adminOrgIdTasksRouteRoute = adminOrgIdTasksRouteRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => adminOrgIdRouteRoute
          })
const adminConsoleIndexRoute = adminConsoleIndexRouteImport.update({
            id: '/console/',path: '/console/',getParentRoute: () => adminRouteRoute
          })
const adminHomeIndexRoute = adminHomeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminHomeRouteRoute
          })
const adminInboxIndexRoute = adminInboxIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminInboxRouteRoute
          })
const adminMineIndexRoute = adminMineIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminMineRouteRoute
          })
const adminSettingsIndexRoute = adminSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminSettingsRouteRoute
          })
const adminSettingsConnectionsRouteRoute = adminSettingsConnectionsRouteRouteImport.update({
            id: '/connections',path: '/connections',getParentRoute: () => adminSettingsRouteRoute
          })
const InviteOrgIdIndexRoute = InviteOrgIdIndexRouteImport.update({
            id: '/invite/$orgId/',path: '/invite/$orgId/',getParentRoute: () => rootRouteImport
          })
const OrgsOrgSlugIndexRoute = OrgsOrgSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrgsOrgSlugRouteRoute
          })
const adminOrgIdReleasesIndexRoute = adminOrgIdReleasesIndexRouteImport.update({
            id: '/releases/',path: '/releases/',getParentRoute: () => adminOrgIdRouteRoute
          })
const adminOrgIdReleasesReleaseSlugRoute = adminOrgIdReleasesReleaseSlugRouteImport.update({
            id: '/releases/$releaseSlug',path: '/releases/$releaseSlug',getParentRoute: () => adminOrgIdRouteRoute
          })
const adminOrgIdTasksIndexRoute = adminOrgIdTasksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminOrgIdTasksRouteRoute
          })
const adminOrgIdTasksTaskShortIdRouteRoute = adminOrgIdTasksTaskShortIdRouteRouteImport.update({
            id: '/$taskShortId',path: '/$taskShortId',getParentRoute: () => adminOrgIdTasksRouteRoute
          })
const adminConsoleConnectionsIndexRoute = adminConsoleConnectionsIndexRouteImport.update({
            id: '/console/connections/',path: '/console/connections/',getParentRoute: () => adminRouteRoute
          })
const adminConsoleOrganizationsOrgIdRoute = adminConsoleOrganizationsOrgIdRouteImport.update({
            id: '/console/organizations/$orgId',path: '/console/organizations/$orgId',getParentRoute: () => adminRouteRoute
          })
const adminConsoleUsersUserIdRoute = adminConsoleUsersUserIdRouteImport.update({
            id: '/console/users/$userId',path: '/console/users/$userId',getParentRoute: () => adminRouteRoute
          })
const adminSettingsApiKeysIndexRoute = adminSettingsApiKeysIndexRouteImport.update({
            id: '/api-keys/',path: '/api-keys/',getParentRoute: () => adminSettingsRouteRoute
          })
const adminSettingsConnectionsIndexRoute = adminSettingsConnectionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminSettingsConnectionsRouteRoute
          })
const adminSettingsOrgOrgIdRouteRoute = adminSettingsOrgOrgIdRouteRouteImport.update({
            id: '/org/$orgId',path: '/org/$orgId',getParentRoute: () => adminSettingsRouteRoute
          })
const adminSettingsSecurityIndexRoute = adminSettingsSecurityIndexRouteImport.update({
            id: '/security/',path: '/security/',getParentRoute: () => adminSettingsRouteRoute
          })
const OrgsOrgSlugShortIdIndexRoute = OrgsOrgSlugShortIdIndexRouteImport.update({
            id: '/$shortId/',path: '/$shortId/',getParentRoute: () => OrgsOrgSlugRouteRoute
          })
const OrgsOrgSlugActivityIndexRoute = OrgsOrgSlugActivityIndexRouteImport.update({
            id: '/activity/',path: '/activity/',getParentRoute: () => OrgsOrgSlugRouteRoute
          })
const OrgsOrgSlugNewIndexRoute = OrgsOrgSlugNewIndexRouteImport.update({
            id: '/new/',path: '/new/',getParentRoute: () => OrgsOrgSlugRouteRoute
          })
const OrgsOrgSlugReleasesIndexRoute = OrgsOrgSlugReleasesIndexRouteImport.update({
            id: '/releases/',path: '/releases/',getParentRoute: () => OrgsOrgSlugRouteRoute
          })
const OrgsOrgSlugRoadmapIndexRoute = OrgsOrgSlugRoadmapIndexRouteImport.update({
            id: '/roadmap/',path: '/roadmap/',getParentRoute: () => OrgsOrgSlugRouteRoute
          })
const adminOrgIdTasksTaskShortIdIndexRoute = adminOrgIdTasksTaskShortIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminOrgIdTasksTaskShortIdRouteRoute
          })
const adminSettingsOrgOrgIdIndexRoute = adminSettingsOrgOrgIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const OrgsOrgSlugReleasesReleaseSlugIndexRoute = OrgsOrgSlugReleasesReleaseSlugIndexRouteImport.update({
            id: '/releases/$releaseSlug/',path: '/releases/$releaseSlug/',getParentRoute: () => OrgsOrgSlugRouteRoute
          })
const adminSettingsOrgOrgIdAiIndexRoute = adminSettingsOrgOrgIdAiIndexRouteImport.update({
            id: '/ai/',path: '/ai/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdBillingIndexRoute = adminSettingsOrgOrgIdBillingIndexRouteImport.update({
            id: '/billing/',path: '/billing/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdCategoriesIndexRoute = adminSettingsOrgOrgIdCategoriesIndexRouteImport.update({
            id: '/categories/',path: '/categories/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdConnectionsIndexRoute = adminSettingsOrgOrgIdConnectionsIndexRouteImport.update({
            id: '/connections/',path: '/connections/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdLabelsIndexRoute = adminSettingsOrgOrgIdLabelsIndexRouteImport.update({
            id: '/labels/',path: '/labels/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdMembersIndexRoute = adminSettingsOrgOrgIdMembersIndexRouteImport.update({
            id: '/members/',path: '/members/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdTeamsIndexRoute = adminSettingsOrgOrgIdTeamsIndexRouteImport.update({
            id: '/teams/',path: '/teams/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdTeamsNewRoute = adminSettingsOrgOrgIdTeamsNewRouteImport.update({
            id: '/teams/new',path: '/teams/new',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdTemplatesIndexRoute = adminSettingsOrgOrgIdTemplatesIndexRouteImport.update({
            id: '/templates/',path: '/templates/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdViewsIndexRoute = adminSettingsOrgOrgIdViewsIndexRouteImport.update({
            id: '/views/',path: '/views/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdConnectionsIntegrationIdIndexRoute = adminSettingsOrgOrgIdConnectionsIntegrationIdIndexRouteImport.update({
            id: '/connections/$integrationId/',path: '/connections/$integrationId/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdConnectionsGithubIndexRoute = adminSettingsOrgOrgIdConnectionsGithubIndexRouteImport.update({
            id: '/connections/github/',path: '/connections/github/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })
const adminSettingsOrgOrgIdTeamsTeamIdIndexRoute = adminSettingsOrgOrgIdTeamsTeamIdIndexRouteImport.update({
            id: '/teams/$teamId/',path: '/teams/$teamId/',getParentRoute: () => adminSettingsOrgOrgIdRouteRoute
          })





const adminOrgIdTasksTaskShortIdRouteRouteChildren = {
  adminOrgIdTasksTaskShortIdIndexRoute: adminOrgIdTasksTaskShortIdIndexRoute
}

const adminOrgIdTasksTaskShortIdRouteRouteWithChildren = adminOrgIdTasksTaskShortIdRouteRoute._addFileChildren(adminOrgIdTasksTaskShortIdRouteRouteChildren)



const adminOrgIdTasksRouteRouteChildren = {
  adminOrgIdTasksTaskShortIdRouteRoute: adminOrgIdTasksTaskShortIdRouteRouteWithChildren,adminOrgIdTasksIndexRoute: adminOrgIdTasksIndexRoute
}

const adminOrgIdTasksRouteRouteWithChildren = adminOrgIdTasksRouteRoute._addFileChildren(adminOrgIdTasksRouteRouteChildren)



const adminOrgIdRouteRouteChildren = {
  adminOrgIdTasksRouteRoute: adminOrgIdTasksRouteRouteWithChildren,adminOrgIdIndexRoute: adminOrgIdIndexRoute,adminOrgIdReleasesReleaseSlugRoute: adminOrgIdReleasesReleaseSlugRoute,adminOrgIdReleasesIndexRoute: adminOrgIdReleasesIndexRoute
}

const adminOrgIdRouteRouteWithChildren = adminOrgIdRouteRoute._addFileChildren(adminOrgIdRouteRouteChildren)




const adminHomeRouteRouteChildren = {
  adminHomeIndexRoute: adminHomeIndexRoute
}

const adminHomeRouteRouteWithChildren = adminHomeRouteRoute._addFileChildren(adminHomeRouteRouteChildren)




const adminInboxRouteRouteChildren = {
  adminInboxIndexRoute: adminInboxIndexRoute
}

const adminInboxRouteRouteWithChildren = adminInboxRouteRoute._addFileChildren(adminInboxRouteRouteChildren)




const adminMineRouteRouteChildren = {
  adminMineIndexRoute: adminMineIndexRoute
}

const adminMineRouteRouteWithChildren = adminMineRouteRoute._addFileChildren(adminMineRouteRouteChildren)




const adminSettingsConnectionsRouteRouteChildren = {
  adminSettingsConnectionsIndexRoute: adminSettingsConnectionsIndexRoute
}

const adminSettingsConnectionsRouteRouteWithChildren = adminSettingsConnectionsRouteRoute._addFileChildren(adminSettingsConnectionsRouteRouteChildren)




const adminSettingsOrgOrgIdRouteRouteChildren = {
  adminSettingsOrgOrgIdIndexRoute: adminSettingsOrgOrgIdIndexRoute,adminSettingsOrgOrgIdTeamsNewRoute: adminSettingsOrgOrgIdTeamsNewRoute,adminSettingsOrgOrgIdAiIndexRoute: adminSettingsOrgOrgIdAiIndexRoute,adminSettingsOrgOrgIdBillingIndexRoute: adminSettingsOrgOrgIdBillingIndexRoute,adminSettingsOrgOrgIdCategoriesIndexRoute: adminSettingsOrgOrgIdCategoriesIndexRoute,adminSettingsOrgOrgIdConnectionsIndexRoute: adminSettingsOrgOrgIdConnectionsIndexRoute,adminSettingsOrgOrgIdLabelsIndexRoute: adminSettingsOrgOrgIdLabelsIndexRoute,adminSettingsOrgOrgIdMembersIndexRoute: adminSettingsOrgOrgIdMembersIndexRoute,adminSettingsOrgOrgIdTeamsIndexRoute: adminSettingsOrgOrgIdTeamsIndexRoute,adminSettingsOrgOrgIdTemplatesIndexRoute: adminSettingsOrgOrgIdTemplatesIndexRoute,adminSettingsOrgOrgIdViewsIndexRoute: adminSettingsOrgOrgIdViewsIndexRoute,adminSettingsOrgOrgIdConnectionsIntegrationIdIndexRoute: adminSettingsOrgOrgIdConnectionsIntegrationIdIndexRoute,adminSettingsOrgOrgIdConnectionsGithubIndexRoute: adminSettingsOrgOrgIdConnectionsGithubIndexRoute,adminSettingsOrgOrgIdTeamsTeamIdIndexRoute: adminSettingsOrgOrgIdTeamsTeamIdIndexRoute
}

const adminSettingsOrgOrgIdRouteRouteWithChildren = adminSettingsOrgOrgIdRouteRoute._addFileChildren(adminSettingsOrgOrgIdRouteRouteChildren)



const adminSettingsRouteRouteChildren = {
  adminSettingsConnectionsRouteRoute: adminSettingsConnectionsRouteRouteWithChildren,adminSettingsIndexRoute: adminSettingsIndexRoute,adminSettingsOrgOrgIdRouteRoute: adminSettingsOrgOrgIdRouteRouteWithChildren,adminSettingsApiKeysIndexRoute: adminSettingsApiKeysIndexRoute,adminSettingsSecurityIndexRoute: adminSettingsSecurityIndexRoute
}

const adminSettingsRouteRouteWithChildren = adminSettingsRouteRoute._addFileChildren(adminSettingsRouteRouteChildren)



const adminRouteRouteChildren = {
  adminOrgIdRouteRoute: adminOrgIdRouteRouteWithChildren,adminHomeRouteRoute: adminHomeRouteRouteWithChildren,adminInboxRouteRoute: adminInboxRouteRouteWithChildren,adminMineRouteRoute: adminMineRouteRouteWithChildren,adminSettingsRouteRoute: adminSettingsRouteRouteWithChildren,adminIndexRoute: adminIndexRoute,adminConsoleIndexRoute: adminConsoleIndexRoute,adminConsoleOrganizationsOrgIdRoute: adminConsoleOrganizationsOrgIdRoute,adminConsoleUsersUserIdRoute: adminConsoleUsersUserIdRoute,adminConsoleConnectionsIndexRoute: adminConsoleConnectionsIndexRoute
}

const adminRouteRouteWithChildren = adminRouteRoute._addFileChildren(adminRouteRouteChildren)




const OrgsOrgSlugRouteRouteChildren = {
  OrgsOrgSlugIndexRoute: OrgsOrgSlugIndexRoute,OrgsOrgSlugShortIdIndexRoute: OrgsOrgSlugShortIdIndexRoute,OrgsOrgSlugActivityIndexRoute: OrgsOrgSlugActivityIndexRoute,OrgsOrgSlugNewIndexRoute: OrgsOrgSlugNewIndexRoute,OrgsOrgSlugReleasesIndexRoute: OrgsOrgSlugReleasesIndexRoute,OrgsOrgSlugRoadmapIndexRoute: OrgsOrgSlugRoadmapIndexRoute,OrgsOrgSlugReleasesReleaseSlugIndexRoute: OrgsOrgSlugReleasesReleaseSlugIndexRoute
}

const OrgsOrgSlugRouteRouteWithChildren = OrgsOrgSlugRouteRoute._addFileChildren(OrgsOrgSlugRouteRouteChildren)

const rootRouteChildren = {
  adminRouteRoute: adminRouteRouteWithChildren,ProsekitTestRoute: ProsekitTestRoute,OrgsOrgSlugRouteRoute: OrgsOrgSlugRouteRouteWithChildren,Auth2faRoute: Auth2faRoute,AuthConsentRoute: AuthConsentRoute,AuthLoginRoute: AuthLoginRoute,AuthPasswordResetRoute: AuthPasswordResetRoute,AuthReauthRoute: AuthReauthRoute,AuthSignupRoute: AuthSignupRoute,InviteOrgIdIndexRoute: InviteOrgIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)